import moment from "moment/moment";
import React from "react";
import { Row } from "react-bootstrap";
import { useParameterizedQuery } from "react-fetching-library";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { Blog, getBlogs } from "../../Actions/BlogActions";
import { AnimateBox } from "../../Components/GenericComponents/AnimateBox";
import { Skeleton } from "../../Components/Skeleton";

const limpiarHtml = (htmlString:any) => {
    const divTemporal = document.createElement('div');
    divTemporal.innerHTML = htmlString;
    return divTemporal.textContent || divTemporal.innerText || '';
};

interface BlogCardProps {
    blog: Blog;
    isSelected?: boolean;
}
const BlogCard : React.FunctionComponent<BlogCardProps> = (props) => {
    const {blog} = props;
    const isSelected = props.isSelected || false;

    const mainClassName = React.useMemo(()=>{
        const dataClass= ["testimonial", "fh5co-selected"];
        if (!isSelected){
            dataClass.push("testimonial-white");
        }

        return dataClass.join(" ");
    }, [isSelected])

    const slug = React.useMemo(()=>{
        const slugData= blog.title.replace(/ /g, "-");
        return encodeURIComponent(slugData);
    }, [blog.title])

    return (
        <div className={mainClassName}>
            <h3>{blog.title}</h3>
            <p>{limpiarHtml(blog.body)}</p>

            <div className="row">
                <div className="col-sm-6 col-sm-push-6">
                    <p className="author" style={{textAlign: "right", fontSize: 14}}>
                        <cite>- <Moment format="LL">{blog.created}</Moment></cite><br />
                        {blog.comments && blog.comments.length > 0 &&
                            <cite>- {blog.comments?.length} Comentarios</cite>
                        }
                    </p>
                </div>

                <div className="col-sm-6 col-sm-pull-6">
                    <Link
                        to={`/blog/${ blog.id }/${slug}`}
                        className="btn btn-primary"
                        onClick={ _e => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        } }
                    >
                        Ver Entrada
                    </Link>
                </div>
            </div>
    </div>
    )
}

export const BlogPage : React.FunctionComponent = (_props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const getBlogsAction = useParameterizedQuery(getBlogs);

    const [blogs, setBlogs] = React.useState<Blog[]>([]);
    const [filterStr, setFilterStr] = React.useState<string>('');

    React.useEffect(()=>{
        if(!isLoading){
            setIsLoading(true);
            getBlogsAction.query({}).then( resp => {
                if(resp.payload){
                    setBlogs(resp.payload);
                }
            } )
        }
    }, [getBlogsAction, isLoading])

    const blogData = React.useMemo(()=>{
        const sortedBlogs = blogs.sort( (a, b) => {
            const mmomentA = moment(a.created)
            const mmomentB = moment(b.created)

            return mmomentA.isBefore(mmomentB) ? -1 : 1;
        } )

        if( filterStr.trim() === '' ){
            return sortedBlogs;
        }

        const filter = filterStr.toLowerCase();

        return sortedBlogs.filter( b => {
            return b.title.toLowerCase().includes(filter)
                || limpiarHtml(b.body).toLowerCase().includes(filter);
        } );
    }, [blogs, filterStr])

    const firstBlog = React.useMemo(()=>{
        if( !isLoading || blogData.length === 0 || filterStr.trim().length !== 0 ) {
            return undefined;
        }

        return blogData[0];
    }, [blogData, filterStr, isLoading])

    const lastBlogs = React.useMemo(()=>{
        if (firstBlog === undefined){
            return blogData;
        }

        return blogData.filter( b => b.id !== firstBlog.id ) ;
    }, [blogData, firstBlog])

    if (getBlogsAction.loading){
        return (
            <React.Fragment>
                <div id="fh5co-who-we-are" className="fh5co-bg-section border-bottom">
                    <div className="container">

                        <Skeleton type="square"></Skeleton>

                        <div className="row" style={{marginTop: 20}}>
                            <div className="col-xs-12 col-sm-6">
                                <Skeleton type="square"></Skeleton>
                            </div>

                            <div className="col-xs-12 col-sm-6">
                                <Skeleton type="square"></Skeleton>
                            </div>
                        </div>

                        <div className="row" style={{marginTop: 20}}>
                            <div className="col-xs-12 col-sm-6">
                                <Skeleton type="square"></Skeleton>
                            </div>

                            <div className="col-xs-12 col-sm-6">
                                <Skeleton type="square"></Skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div id="fh5co-who-we-are" className="fh5co-bg-section border-bottom">
                <div className="container">

                    <AnimateBox className="row animate-box row-pb-md" data-animate-effect="fadeInUp">
                        <div className="col-sm-8 col-sm-offset-2 text-left fh5co-heading">
                            <form action="#">
                                <div className="row form-group">
                                    <div className="col-sm-12">
                                        <label htmlFor="fname">Búscas algo en especial...</label>
                                        <input type="text"
                                               id="fname"
                                               className="form-control"
                                               placeholder="Búsqueda de Articulos"
                                               onChange={ (e) => setFilterStr(e.target.value) }
                                               value={filterStr}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </AnimateBox>

                    <div id="fh5co-testimonial" className="fh5co-bg-section">
                        { firstBlog && <AnimateBox><BlogCard blog={firstBlog} key={firstBlog.id} isSelected /></AnimateBox> }
                        { lastBlogs.length > 0 && (
                            <Row className="flex-row">
                            {lastBlogs.map( blog => (
                                <AnimateBox className="col-xs-12 col-sm-6" key={blog.id}>
                                    <BlogCard blog={blog} />
                                </AnimateBox>
                            )) }
                            </Row>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}